import AsyncStorage from "@react-native-async-storage/async-storage";

export const fetchBermadData = async () => {
  const url = "https://api2.bermad.io/graphql";

  let bermadProjectId = null;

  try {
    const projCodeValue = await AsyncStorage.getItem("projectAllData");

    if (projCodeValue) {
      const parsedProject = JSON.parse(projCodeValue);

      bermadProjectId = parsedProject.bermad_project_id;
    } else {
    }
  } catch (error) {
    console.error("Error getting projectAllData:", error);
  }

  // const query = `
  //   query unitsStatusTable(
  //     $ids: [String],
  //     $pageIndex: Int,
  //     $pageSize: Int,
  //     $isOnline: Boolean,
  //     $isOffline: Boolean,
  //     $nextIrrigationFrom: String,
  //     $nextIrrigationTo: String,
  //     $LastIrrigationFrom: String,
  //     $LastIrrigationTo: String,
  //     $showRunningIrrigation: Boolean,
  //     $showIdleIrrigation: Boolean,
  //     $showUnitsWithErrors: Boolean,
  //     $showUnitsWithoutErrors: Boolean,
  //     $searchString: String
  //   ) {
  //     realtimeTable(
  //       ids: $ids
  //       pageIndex: $pageIndex
  //       pageSize: $pageSize
  //       isOnline: $isOnline
  //       isOffline: $isOffline
  //       nextIrrigationFrom: $nextIrrigationFrom
  //       nextIrrigationTo: $nextIrrigationTo
  //       LastIrrigationFrom: $LastIrrigationFrom
  //       LastIrrigationTo: $LastIrrigationTo
  //       showRunningIrrigation: $showRunningIrrigation
  //       showIdleIrrigation: $showIdleIrrigation
  //       showUnitsWithErrors: $showUnitsWithErrors
  //       showUnitsWithoutErrors: $showUnitsWithoutErrors
  //       searchString: $searchString
  //     ) {
  //       unitsStatusTable {
  //         id
  //         unitName
  //         projectId
  //         projectName
  //         serial
  //         status
  //         isOnline
  //         lastConnection
  //         valves {
  //           index
  //           state
  //           status
  //           name
  //         }
  //         watermeters {
  //           id
  //           flow
  //           totalizer
  //           name
  //         }
  //         switches {
  //           index
  //           state
  //           name
  //           value
  //         }
  //         analogs {
  //           error
  //           index
  //           status
  //           value
  //           name
  //           __typename
  //     }
  //       }
  //       totalRows
  //     }
  //   }
  // `;

  const query = `
    query unitsStatusTable(
  $ids: [String],
  $pageIndex: Int,
  $pageSize: Int,
  $isOnline: Boolean,
  $isOffline: Boolean,
  $nextIrrigationFrom: String,
  $nextIrrigationTo: String,
  $LastIrrigationFrom: String,
  $LastIrrigationTo: String,
  $showRunningIrrigation: Boolean,
  $showIdleIrrigation: Boolean,
  $showUnitsWithErrors: Boolean,
  $showUnitsWithoutErrors: Boolean,
  $searchString: String
) {
  realtimeTable(
    ids: $ids
    pageIndex: $pageIndex
    pageSize: $pageSize
    isOnline: $isOnline
    isOffline: $isOffline
    nextIrrigationFrom: $nextIrrigationFrom
    nextIrrigationTo: $nextIrrigationTo
    LastIrrigationFrom: $LastIrrigationFrom
    LastIrrigationTo: $LastIrrigationTo
    showRunningIrrigation: $showRunningIrrigation
    showIdleIrrigation: $showIdleIrrigation
    showUnitsWithErrors: $showUnitsWithErrors
    showUnitsWithoutErrors: $showUnitsWithoutErrors
    searchString: $searchString
  ) {
    unitsStatusTable {
      id
      paymentStatus
      unitName
      projectId
      projectName
      programName
      serial
      digitals
      errors
      onlineStatus
      isLowPower
      status
      firmwareId
      lastConnection
      lastIrrigationTime
      lastIrrigationName
      nextIrrigationProgramId
      nextIrrigationName
      nextIrrigationTime
      unitConfigSync
      updated
      controllerType
      controllerDescription
      wake_up_times
      applicationMode
      nextConnectionDate
      batteryVoltage
      coreBatteryVoltage
      modemBatteryVoltage

      programs {
        cyc_left
        index
        flow
        leftover
        progress
        next_vlv_index
        state
        type
        valve_index
        name
        __typename
      }

      analogs {
        index
        status
        value
        name
        __typename
      }

      valves {
        index
        state
        status
        name
        watermeter_id
        __typename
      }

      fertilizers {
        flow
        index
        progress
        leftover
        type
        state
        valve_index
        name
        waterMeterId
        __typename
      }

      switches {
        index
        value
        name
        __typename
      }

      watermeters {
        flow
        index
        status
        totalizer
        name
        id
        __typename
      }

      deltaFlowData {
        pressureP1Avg
        pressureP2Avg
        flowAvg
        __typename
      }

      epsilonFlowData {
        sensorName
        flowAvg
        type
        __typename
      }

      __typename
    }
    totalRows
    __typename
  }
}

  `;
  const variables = {
    pageIndex: 0,
    pageSize: 1000,
    ids: [String(bermadProjectId)],
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJja2syZGdnNTQxNDQwNzB2cnJtcHhxaXY0OSIsImlhdCI6MTc1NzA1NTk1OH0.n8fyKmQ2j5PFtWQ7jZoUqb_z82z4yx51F-BrbfsmgCI",
      },
      body: JSON.stringify({ query, variables }),
    });

    const result = await response.json();
    return result.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};
